import { createApiClient, addResponseInterceptor } from "./base-api-client";
import type { AxiosInstance, AxiosResponse } from "axios";

function getApiBaseUrl(): string {
  const envUrl: unknown = import.meta.env["VITE_API_BASE_URL"];
  if (typeof envUrl === "string" && envUrl.length > 0) {
    return envUrl;
  }
  return "";
}

function createHttpClient(): AxiosInstance {
  const client = createApiClient({
    baseURL: getApiBaseUrl(),
    timeout: 30000,
    withCredentials: true,
  });

  addResponseInterceptor(
    client,
    (response: AxiosResponse) => response,
    (error: unknown) => {
      if (import.meta.env["DEV"] === true) {
        console.error("[API Error]", error);
      }
      return Promise.reject(error);
    },
  );

  return client;
}

export const httpClient: AxiosInstance = createHttpClient();
